export const errorMessage = (errors) => {
    if (errors?.response?.status === 500) return 'common.internal_server_error';

    if (errors?.response?.status === 413) return 'common.request_entity_too_large';

    if (errors?.response?.data?.error_data) {
        // PeopleForce returns errors in case email or attachment duplicates
        return errors?.response?.data?.error_data.map(error => `${error.split(' for ')?.[0]}.`).join(' ');
    }

    return errors?.response?.data?.error_description;
}
